import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { MessageService } from 'primeng/components/common/messageservice';

import { BaseService } from '../../base/util/base.service';
import {
  buscarContrato,
  deletarContrato,
  downloadArquivoVinculo,
  editarContrato,
  exportarAssinaturas,
  listarContratos,
  tiposContrato,
  uploadCSV,
  URL_DOCUMENTOS,
  vincularPrestadores,
} from '../../base/util/url-util';
import { Contrato, ContratoForm, TipoContrato } from '../../base/vo/contrato';


@Injectable()
export class AdminContratosService extends BaseService {

  private documentoMap = {
    1: 'Contrato',
    2: 'Aditivo',
    3: 'DocuWare',
  };

  constructor(
    public http: HttpClient,
    public messageService: MessageService
  ) {
    super(http, messageService);
  }

  public getContratos(page: number, nItemsPerPage: number): Observable<any> {
    return this.get(listarContratos(page, nItemsPerPage));
  }

  public getTiposContrato(): Observable<TipoContrato[]> {
    return this.get(tiposContrato());
  }

  public getContrato(id: number): Observable<any> {
    return this.http.get(buscarContrato(id));
  }

  public saveContrato(contratoForm: ContratoForm): Observable<any> {
    return this.post(URL_DOCUMENTOS, contratoForm);
  }

  public editContrato(id: number, contratoForm: ContratoForm): Observable<any> {
    return this.patch(editarContrato(id), contratoForm)
  }

  public deleteContrato(id: number): Observable<any> {
    return this.delete(deletarContrato(id));
  }

  public csvToFormData(file: File): FormData {
    const convertedFile = new FormData();
    convertedFile.append('file', file, file.name);
    return convertedFile;
  }
  
  public downloadCsv(id:number) {
    return this.http.get(exportarAssinaturas(id),  {responseType: 'blob'});
  }

  public downloadArquivoVinculo(id: number) {
    return this.http.get(downloadArquivoVinculo(id),   {responseType: 'blob'});
  }

  public uploadCSV(id: number, file: FormData) {
    const headers = new HttpHeaders();
    headers.set('Content-Type', null);
    headers.set('Accept', 'multipart/form-data');
    return this.post(uploadCSV(id), file, headers);
  }

  public postVinculo(id: number, urlAnexo: string): Observable<Contrato> {
    return this.post(vincularPrestadores(id), {'urlAnexoVinculo': urlAnexo});
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/contratos/admin-contratos.service.ts